/**
 * Client configuration from Vite env (`VITE_*`). Getters read `import.meta.env`
 * on each access so tests can `vi.stubEnv` before exercising code.
 */

function str(key, defaultValue = "") {
  const v = import.meta.env[key];
  if (v === undefined || v === null || v === "") return defaultValue;
  return String(v);
}

export const settings = Object.freeze({
  get googleMapsApiKey() {
    return str("VITE_GOOGLE_MAPS_API_KEY");
  },
  get dmqtApiHost() {
    return str("VITE_DMQT_API_HOST");
  },
  get dataCatalogUrlBase() {
    return str("VITE_TDIS_DATA_CATALOG_URL_BASE");
  },
  get mapboxKey() {
    return str("VITE_MAPBOX_KEY");
  },
  get keycloakUrl() {
    return str("VITE_KEYCLOAK_URL", "https://tdis-authx-dev.azurewebsites.net");
  },
  get keycloakRealm() {
    return str("VITE_KEYCLOAK_REALM", "DMQT");
  },
  get keycloakClientId() {
    return str("VITE_KEYCLOAK_CLIENT_ID", "tdis-catalog-search");
  },
  get googleAnalyticsToken() {
    return str("VITE_GOOGLE_ANALYTICS_TOKEN");
  },
});
